var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStickerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59001 20 4.00001 16.41 4.00001 12C4.00001 7.59001 7.59001 4.00001 12 4.00001C16.41 4.00001 20 7.59001 20 12C20 16.41 16.41 20 12 20ZM15.5477 14.3895C15.7682 14.0146 16.2615 13.8967 16.6289 14.1324C16.9962 14.3681 17.1117 14.8609 16.8808 15.2359C15.8102 16.9608 13.9943 18 12 18C10.0057 18 8.18984 16.9715 7.11922 15.2252C6.8883 14.8502 7.00376 14.3574 7.37113 14.1217C7.7385 13.886 8.22133 14.0038 8.45225 14.3788C9.22898 15.643 10.5515 16.393 12 16.393C13.4485 16.393 14.771 15.643 15.5477 14.3895ZM10 9.5C10 10.3284 9.32843 11 8.5 11C7.67157 11 7 10.3284 7 9.5C7 8.67157 7.67157 8 8.5 8C9.32843 8 10 8.67157 10 9.5ZM15.5 11C16.3284 11 17 10.3284 17 9.5C17 8.67157 16.3284 8 15.5 8C14.6716 8 14 8.67157 14 9.5C14 10.3284 14.6716 11 15.5 11Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStickerIcon);
export default __webpack_public_path__ + "static/media/sticker_icon.24f85ffc.svg";
export { ForwardRef as ReactComponent };